export const formatPhoneNumber = (phone) => {
    const cleaned = phone.replace(/\D/g, ''); // Remove non-digits from phone number
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match three groups of three digits and four digits
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`; // Format as (xxx) xxx-xxxx
    }
    return phone; // Return the original phone number if no match found
  };